// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-wrapper {
  position: relative;
}

.pgmtextfield_dropdown input {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 2.3rem;
  margin: 10px;
  line-height: 6ex;
}

.search-input-pgm {
  width: 47%;
}

.search-placeholder::placeholder {
  font-size: 12px;
  color: gray;
}

label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}

.select-wrapper {
  position: relative;
  display: block;
}

.input::placeholder {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
}

select {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 94%;
  height: 2.5rem;
}

.pgm_list_textfield_textfield_containers {
  display: flex;
  gap: 1.4rem;
  width: 95%;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  margin: 1rem;
  padding: 0.6rem 0px;
}

.pgmtextfield_dropdown {
  width: 100%;
  display: flex;
}
.pgmtextfield_dropdown .partner-date-search {
  display: flex;
}

.input-wrapper select {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 90% !important;
  height: 2.3rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132E;
  padding: 0rem 0.5rem;
}

.button_search-pgmlist {
  background-color: #0C3688;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
  width: 10% !important;
  height: 2.5rem;
  text-align: center;
  justify-content: center;
  border: none;
  margin: 0.6rem 10px !important;
}

.button_search-pgmlist:disabled, .button_search-pgmlist:hover {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
  box-shadow: 0px 3px 10px rgba(54, 79, 130, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #ebe9e9;
  width: 10%;
  height: 2.5rem;
  text-align: center;
  justify-content: center;
  border: none;
  margin: 0.6rem 1rem;
}

@media screen and (max-width: 768px) {
  .pgm_list_textfield_textfield_containers {
    flex-direction: column;
  }
  .pgmtextfield_dropdown {
    display: flex;
    flex-wrap: wrap;
  }
  .input-wrapper select {
    width: 92% !important;
  }
  .partner-date-search {
    width: 96%;
  }
  .partner-date-search .input-wrapper {
    width: 50% !important;
  }
  .search-input-pgm {
    width: 100% !important;
  }
  .select-pgm-filter {
    width: 48% !important;
  }
  .button_search-pgmlist {
    width: 92% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/PgmTextfieldComponent/Pgmtextfield.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF;;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAEF;;AAAA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AAGF;;AADA;EACE,aAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAIF;;AADA;EACE,WAAA;EACA,aAAA;AAIF;AADE;EACE,aAAA;AAGJ;;AACA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AAEF;;AAAA;EACE,yBAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,8BAAA;AAGF;;AADA;EACE,mEAAA;EACA,+CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AAIF;;AAuBA;EAEE;IACE,sBAAA;EArBF;EAuBA;IACE,aAAA;IACA,eAAA;EArBF;EAwBA;IACE,qBAAA;EAtBF;EAyBA;IACE,UAAA;EAvBF;EAyBE;IACE,qBAAA;EAvBJ;EA2BA;IACE,sBAAA;EAzBF;EA4BA;IACE,qBAAA;EA1BF;EA6BA;IACE,qBAAA;EA3BF;AACF","sourcesContent":[".input-wrapper {\n  position: relative;\n}\n\n.pgmtextfield_dropdown input {\n  border: 1px solid gray;\n  border-radius: 6px;\n  position: relative;\n  width: 92%;\n  height: 2.3rem;\n  margin: 10px;\n  line-height: 6ex;\n}\n\n.search-input-pgm{\n  width: 47%;\n}\n\n.search-placeholder::placeholder{\n  font-size: 12px;\n  color: gray\n}\n\nlabel {\n  position: absolute;\n  top: 0.2ex;\n  z-index: 1;\n  left: 2em;\n  background-color: white;\n  padding: 0 5px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #0c3688;\n}\n\n.select-wrapper {\n  position: relative;\n  display: block;\n}\n.input::placeholder {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  color: #10132e;\n}\nselect {\n  border: 1px solid gray;\n  border-radius: 6px;\n  position: relative;\n  margin: 10px;\n  line-height: 6ex;\n  width: 94%;\n  height: 2.5rem;\n}\n.pgm_list_textfield_textfield_containers{\n  display: flex;\n  gap: 1.4rem ;\n  width: 95%;\n  background: #ffffff;\n  border: 1px solid #c1c6d0;\n  border-radius: 6px;\n  background: #ffffff;\n  border: 1px solid #c1c6d0;\n  border-radius: 6px;\n  margin: 1rem;\n  padding: 0.6rem 0px;\n}\n\n.pgmtextfield_dropdown{\n  width: 100%;\n  display: flex;\n\n\n  .partner-date-search{\n    display: flex;\n  }\n}\n\n.input-wrapper select {\n  border: 1px solid gray;\n  border-radius: 6px;\n  position: relative;\n  margin: 10px;\n  line-height: 6ex;\n  width: 90% !important;\n  height: 2.3rem;\n  font-family: 'Nunito';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  color: #10132E;\n  padding: 0rem 0.5rem;\n}\n.button_search-pgmlist {\n  background-color: #0C3688;\n  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n  border-radius: 5px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  color: #ffffff;\n  width: 10% !important;\n  height: 2.5rem;\n  text-align: center;\n  justify-content: center;\n  border: none;\n  margin: 0.6rem 10px !important;\n}\n.button_search-pgmlist:disabled,.button_search-pgmlist:hover{\n  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n  box-shadow: 0px 3px 10px rgba(54, 79, 130, 0.4);\n  border-radius: 5px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  color: #ebe9e9;\n  width: 10%;\n  height: 2.5rem;\n  text-align: center;\n  justify-content: center;\n  border: none;\n  margin: 0.6rem 1rem;\n}\n\n// @media screen and (max-width: 448px) {\n//   .pgm_list_textfield_textfield_containers{\n//     flex-direction: column;\n//   }\n\n//   .pgmtextfield_dropdown .input-wrapper{\n//     width: 100%;\n//   }\n\n//   .pgm_list_textfield_textfield_containers .button_search-pgmlist{\n//     width: 93% !important;\n//     margin: auto;\n//   }\n\n//   .pgmtextfield_dropdown{\n//     display: flex;\n//     flex-wrap: wrap;\n//   }\n\n//   .input-wrapper select{\n//     width: 92% !important;\n//   }\n// }\n\n@media screen and (max-width: 768px) {\n\n  .pgm_list_textfield_textfield_containers{\n    flex-direction: column;\n  }\n  .pgmtextfield_dropdown{\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .input-wrapper select{\n    width: 92% !important;\n  }\n\n  .partner-date-search{\n    width: 96%;\n\n    .input-wrapper{\n      width: 50% !important;\n    }\n  }\n\n  .search-input-pgm{\n    width: 100% !important;\n  }\n\n  .select-pgm-filter{\n    width: 48% !important;\n  }\n\n  .button_search-pgmlist{\n    width: 92% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
